import { isDraftSaveAction } from '../../../Draft'
import { RentalPortalListingDraftCloseActionSelectModal } from '../../RentalPortalListingDraft'

export function useRentalPortalListingDraftCloseConfirmation(setDraft) {
  function handleSubmit(action) {
    if (!isDraftSaveAction(action)) {
      setDraft(null, 0)
    }
  }

  return {
    Component: RentalPortalListingDraftCloseActionSelectModal,
    onSubmit: handleSubmit,
  }
}
